import React, { useEffect, useState } from 'react';
import { WorkerTitle, SetLoading } from '../SiteClasses';
import { useBreadcrumbs, useUser } from '../hooks';
import { Toast, Header, Groupper, Button, Table, Pagination, Input, Modal, Message, Icon } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import { addCommas, bindClick, bindFormChange } from '../SiteUtil';
import Validator from '../Validator';
import classNames from 'classnames';
import moment from 'moment';
import UserAccess from '../UserAccess';
import API from '../API';

const PAGE_SIZE = 20;

interface TitleForm{
	title_id?: number;
	title_name: string;
	payout_amount: number;
}

interface TitlesListProps{
	
}

var TitlesList = (props: TitlesListProps)=>{
	var { user, hasAccess } = useUser();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [titlesList, setTitleslist] = useState<WorkerTitle []>(null);
	var [searchTitles, setSearchTitles] = useState<WorkerTitle []>(null);
	var [page, setPage] = useState<number>(0);
	var [filter, setFilter] = useState<string>('');
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [createModal, setCreateModal] = useState<boolean>(false);
	var [titleForm, setTitleForm] = useState<TitleForm>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);
	var [infoModal, setInfoModal] = useState<boolean>(false);
	var [selectedTitle, setSelectedTitle] = useState<WorkerTitle>(null);
	var [deleteModal, setDeleteModal] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Puestos');
		get();
	}, []);

	var get = (get_page?: number) => {
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getTitles(PAGE_SIZE, offset).then(res => {
			if (res.error) return setLoadError(res.message);
			return setTitleslist(res.data);
		}).catch(err => {
			return setLoadError('Hubo un error al obtener los trabajadores. (GES-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
		setLoading(true)
		setPage(page);
		get(page);
	};

	var search = (query: string)=>{
		setSearching(true);
		setSearchTimeout(null);
		API.searchTitles(query).then(res=>{
			if (res.error) return setLoadError(res.message);
			setSearchTitles(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar la posición. (SWT-1)');
		}).finally(()=>{
			setSearching(false);
		})
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			return setSearchTitles(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	};

	var submit = async(setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(titleForm, {
			title_name: [{
				rule: 'minLength', params: [3], label: 'Nombre de puesto'
			}],
			payout_amount: [{
				rule: 'number', label: 'Sueldo'
			}],
		});
		setModalPrompts(prompts);
		if (!valid) return;
		setLoading(true);
		if(!titleForm.title_id){
			API.createTitle(titleForm.title_name, titleForm.payout_amount).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Puesto creado!');	
				titlesList.push({
					title_id: res.data.title_id,
					title_name: titleForm.title_name,
					deleted: false,
					date_created: moment().unix(),
					user_creator_name: (user.first_name + ' ' +user.last_name),
					user_creator: user.user_id,
					date_deleted: null,
					payout_amount: titleForm.payout_amount
				})
				setTitleslist(titlesList);
				setCreateModal(false);
			}).catch(err=>{
				Toast.error('Hubo un error inesperado creando el puesto. (LCL-1)');
			}).finally(()=>{	
				setLoading(false);
			})
		}else{
			API.editTitle(titleForm.title_id, titleForm.title_name, titleForm.payout_amount).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Puesto actualizado!');	
				var i = titlesList.findIndex(t => t.title_id === titleForm.title_id);
				titlesList[i].title_name = titleForm.title_name;
				titlesList[i].payout_amount = titleForm.payout_amount;
				setTitleslist(titlesList);
				setCreateModal(false);
			}).catch(err=>{
				Toast.error('Hubo un error inesperado actualizando el puesto. (LCL-1)');
			}).finally(()=>{	
				setLoading(false);
			})
		}
	}

	var onShowCreateModal = (t: WorkerTitle)=>{
		if(!!t){
			setTitleForm({
				title_id: t.title_id,
				title_name: t.title_name,
				payout_amount: t.payout_amount
			})
		}else{
			setTitleForm({
				title_id: null,
				title_name: '',
				payout_amount: null
			})
		}
		setCreateModal(true);
	}

	var onShowInfoModal = (t: WorkerTitle) =>{
		setSelectedTitle(t);
		setInfoModal(true);
	}

	var onShowDeleteModal = (t: WorkerTitle)=>{
		setSelectedTitle(t);
		setDeleteModal(true);
	}

	var deleteTitle = (setLoading: SetLoading)=>{
		setLoading(true);
		API.deleteTitle(selectedTitle.title_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Puesto eliminado!');
			var i = titlesList.findIndex(t => t.title_id === selectedTitle.title_id);
			titlesList[i].deleted = true;
			setTitleslist(titlesList);
			setDeleteModal(false);
			setSelectedTitle(null);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado eliminando el puesto. (LCL-1)');
		}).finally(()=>{	
			setLoading(false);
		})
	}

	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!titlesList) { return <Header text='Cargando datos' loading/> };

	var onFormChange = bindFormChange(titleForm, setTitleForm);
	var shown_titles = searchTitles || titlesList;

	return <div>
		<Groupper
			title={'Puestos'}
			width={600}
			style={{ marginTop: 20 }}
			titleRight={hasAccess(UserAccess.WORKERS.CREATE_WORKERS_TITLES) && (
				<Button iconName='plus' color='black' text='Agregar' size='small' onClick={() => onShowCreateModal(null)}/>
			)}
		>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} style={{ margin: 0 }} />
			<Table striped
				className='first last'
				style={{ marginTop: 15 }}
				headers={['ID', 'Nombre', 'Sueldo', <Icon name='wrench' />]}
				footer={(!!shown_titles && shown_titles.length >= PAGE_SIZE || page !== 0) && (
					<Table.Cell colSpan={10} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_titles.length>=PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={7}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_titles.length !== 0 ? (
						shown_titles.map(t => (
							<Table.Row
								key={t.title_id}
								collapsingIndexes={[0, 2, 3]}
								data={[
									t.title_id,
									t.title_name,
									
									
									
									
									
									
									
									'$'+addCommas(t.payout_amount),
									<Dropdown icon={(
										<div className="fr label" style={{ padding: '3px 10px' }}>
											<Icon name='ellipsis' style={{ margin: 0 }} />
										</div>
									)} className='icon'>
										<Dropdown.Menu>
											<Dropdown.Item onClick={()=> onShowInfoModal(t)}>
												<Icon name="eye" style={{ marginRight: 3 }} /> Info 
											</Dropdown.Item>
											{hasAccess(UserAccess.WORKERS.EDIT_WORKERS_TITLES) && (
												<Dropdown.Item onClick={()=> onShowCreateModal(t)}>
													<Icon name="pen" style={{ marginRight: 3 }} /> Editar 
												</Dropdown.Item>
											)}
											{!t.deleted && hasAccess(UserAccess.WORKERS.DELETE_WORKERS_TITLES) ? <Dropdown.Item onClick={()=>onShowDeleteModal(t)}>
												<Icon name="remove" style={{ marginRight: 3 }} /> Eliminar 
											</Dropdown.Item> : null}
										</Dropdown.Menu>
									</Dropdown>
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={6}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
			{}
		</Groupper>
		<Modal open={createModal} onClose={bindClick(setCreateModal, false)} size='tiny'>
			{titleForm && <Modal.Header>{titleForm.title_id ? 'Editar puesto' : 'Crear puesto'}</Modal.Header>}
			{titleForm && <Modal.Content>
				<Input label='Nombre de puesto' comment='Ej. LES, Control de acceso, etc' value={titleForm.title_name} onChange={onFormChange('title_name')}/>
				<Input label='Sueldo base' comment='Suedo base que se le asiganrá a los trabajadores con este puesto. Este es solamente se tomará como base y podrá ser cambiado por evento o trabajador' value={titleForm.payout_amount} onChange={onFormChange('payout_amount')}/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button basic text='Cancelar' onClick={bindClick(setCreateModal, false)}/>
				{titleForm && <Button color="black" text={titleForm.title_id ? 'Guardar' : 'Crear'} onClick={submit}/>}
			</Modal.Actions>
		</Modal>
		<Modal open={infoModal} onClose={bindClick(setInfoModal)} size='tiny'>
			<Modal.Header>Información de puesto</Modal.Header>
			{selectedTitle && <Modal.Content style={{ paddingBottom: 0 }}>
				<Table 
					details
					striped
					fitted
					data={[
						['ID', selectedTitle.title_id],
						['Nombre', selectedTitle.title_name],
						['Sueldo', '$'+addCommas(selectedTitle.payout_amount)],
						['Creador', selectedTitle.user_creator_name],
						['Creación', moment.unix(selectedTitle.date_created).format('DD/MM/YY HH:mm')],
						['Estatus', (
							<div className={classNames("fr label", {
								green: !selectedTitle.deleted,
								red: selectedTitle.deleted,
							})}>
								{selectedTitle.deleted ? 'Eliminado' : 'Activo'}
							</div>
						)]
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setInfoModal, null)} />
			</Modal.Actions>
		</Modal>
		<Modal open={deleteModal} onClose={bindClick(setDeleteModal)} size='tiny'>
			<Modal.Header>¿Eliminar puesto?</Modal.Header>
			{selectedTitle && <Modal.Content>
				<Table 
					details
					striped
					data={[
						['ID', selectedTitle.title_id],
						['Nombre', selectedTitle.title_name],
						['Sueldo', '$'+addCommas(selectedTitle.payout_amount)],
						['Estatus', (
							<div className={classNames("fr label", {
								green: !selectedTitle.deleted,
								red: selectedTitle.deleted,
							})}>
								{selectedTitle.deleted ? 'Eliminado' : 'Activo'}
							</div>
						)]
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setDeleteModal, null)} />
				<Button text='Eliminar' color='red' onClick={deleteTitle}/>
			</Modal.Actions>
		</Modal>
	</div>
}

export default TitlesList;